import { render, staticRenderFns } from "./ProuniEducationForm.vue?vue&type=template&id=389e6e25&scoped=true&"
import script from "./ProuniEducationForm.vue?vue&type=script&lang=ts&"
export * from "./ProuniEducationForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniEducationForm.vue?vue&type=style&index=0&id=389e6e25&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e6e25",
  null
  
)

export default component.exports